import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import * as SecureLS from "secure-ls";
import { GlobalService } from '../../services/global.service';
import { StorageService } from '../../services/storage.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-student-bookmark',
  templateUrl: './student-bookmark.component.html',
  styleUrls: ['./student-bookmark.component.css']
})
export class StudentBookmarkComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  @Input() showBookmarkList;
  @Input() mediaPlayerEvent;
  bookmarkForm: FormGroup;
  onlyView = false;
  bookmarkTopicList:any[] = [];
  showDDMenu = false;
  spinners = false;
  seconds = true;
  showSaveBookmarkBtn = false;
  bookmarkTopicDataForEdit: Object;
  bookmarkcount: number;
  constructor(
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public router: ActivatedRoute,
    public globalService: GlobalService,
    private storageService: StorageService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.onlyView = this.storageService.getRole() == 4;
    this.bookmarkForm = this.fb.group({
      title: [{ value: "", disabled: false }, [Validators.required]],
      filter_start: [{ value: "", disabled: false }, [Validators.required]],
      filter_end: [{ value: "", disabled: false }, [Validators.required]],
    });
    await this.getBookmarkTopics();
  }
  get forms1() {
    return this.bookmarkForm.controls;
  }

  async getBookmarkTopics() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      role_id: this.storageService.getRole(),
    };

    let bookmarkTopic = await this.globalService.get("bookmark/list", filter,true);
    if (bookmarkTopic["status"] == 200) {
      this.bookmarkTopicList = this.resetDDMenu(
        bookmarkTopic["content"]
      );
      this.bookmarkcount = this.bookmarkTopicList.length
      this.spinner.hide();
    } else {
      this.bookmarkcount = 0;
      this.spinner.hide();
    }
  }

  resetDDMenu(bookmarkTopicList) {
    return bookmarkTopicList?.map((list) => {
      if (list.hasOwnProperty("isDDMenuShow")) {
        list.isDDMenuShow = false;
      } else {
        list = { ...list, isDDMenuShow: false };
      }
      return list;
    });
  }

  

  async onCreateBookmark() {
    if(this.bookmarkForm.invalid) {
      return;
    }
    this.spinner.show();
    let start_second = this.bookmarkForm.controls["filter_start"].value.second;
    let start_min = this.bookmarkForm.controls["filter_start"].value.minute * 60;
    let start_hrs = this.bookmarkForm.controls["filter_start"].value.hour * 60 * 60;

    let end_second = this.bookmarkForm.controls["filter_end"].value.second;
    let end_min = this.bookmarkForm.controls["filter_end"].value.minute * 60;
    let end_hrs = this.bookmarkForm.controls["filter_end"].value.hour * 60 * 60;

    let StotalBookmarkTopic = start_second + start_min + start_hrs;
    let EtotalBookmarkTopic = end_second + end_min + end_hrs;
    let requestPayload = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      title: this.bookmarkForm.controls["title"].value,
      filter_start: StotalBookmarkTopic,
      filter_end: EtotalBookmarkTopic
    };

    let createdBookmarkTopic = await this.globalService.create(
      "bookmark/add",
      requestPayload
    );
    if (createdBookmarkTopic["status"] == 200) {
      Swal.fire("Success!", createdBookmarkTopic["message"], "success");
      this.bookmarkForm.reset();
      await this.getBookmarkTopics();
    } else {
      this.spinner.hide();
    }
  }

  async onSaveBookmark() {
    if(this.bookmarkForm.invalid) {
      return;
    }
    this.spinner.show();
    let start_second = this.bookmarkForm.controls["filter_start"].value.second;
    let start_min = this.bookmarkForm.controls["filter_start"].value.minute * 60;
    let start_hrs = this.bookmarkForm.controls["filter_start"].value.hour * 60 * 60;

    let end_second = this.bookmarkForm.controls["filter_end"].value.second;
    let end_min = this.bookmarkForm.controls["filter_end"].value.minute * 60;
    let end_hrs = this.bookmarkForm.controls["filter_end"].value.hour * 60 * 60;

    let StotalBookmarkTopicTime = start_second + start_min + start_hrs;
    let EtotalBookmarkTopicTime = end_second + end_min + end_hrs;
    let requestPayload = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      title: this.bookmarkForm.controls["title"].value,
      filter_start: StotalBookmarkTopicTime,
      filter_end: EtotalBookmarkTopicTime,
      id: this.bookmarkTopicDataForEdit["content"]["id"]
    };

    let savedBookmarkTopic = await this.globalService.update(
      "bookmark/update",
      requestPayload
    );
    if (savedBookmarkTopic["status"] == 200) {
      Swal.fire("Success!", savedBookmarkTopic["message"], "success");
      this.onResetBookmark();
      this.getBookmarkTopics();
      this.spinner.hide();
    } else {
      this.spinner.hide();
    }
  }

  onMoveToBookmark(bookmarkTopic) {
    this.mediaPlayerEvent.seekTime(bookmarkTopic?.filter_start, false);
    this.mediaPlayerEvent.getDefaultMedia().currentTime =
      bookmarkTopic?.filter_start;
    this.mediaPlayerEvent.play();
  }

  onResetBookmark() {
    this.bookmarkForm.reset();
    this.showSaveBookmarkBtn = false;
  }
  addZeroPrefix(n): string {
    return (`${n}`.length == 1) ? `0${n}` : `${n}`
  }
  getReadableTime(duration, isNeedObj?) {
    let start;
    let startObj = {};
    if (duration < 3600) {
      var a = Math.floor(duration / 60); //minutes
      var b = duration % 60; //seconds

      start =  this.addZeroPrefix(a) + ":" + this.addZeroPrefix(b);
      startObj['hour'] = 0;
      startObj['minute'] = a;
      startObj['second'] = b;
    } else {
      var a = Math.floor(duration / 3600); //hours
      var x = duration % 3600;
      var b = Math.floor(x / 60); //minutes
      var c = duration % 60; //seconds

      start = this.addZeroPrefix(a) + ":" + this.addZeroPrefix(b) + ":" + this.addZeroPrefix(c);
      startObj['hour'] = a;
      startObj['minute'] = b;
      startObj['second'] = c;
    }
    return (isNeedObj) ? startObj : start;
  }

  onEditBookmarkTopic(bookmarkTopic) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          class_room_video_details_id: this.router.snapshot.queryParams.key,
          id: bookmarkTopic.id,
          title: bookmarkTopic.title,
          role_id: this.storageService.getRole(),
        };

        this.bookmarkTopicDataForEdit = await this.globalService.get(
          "bookmark/get",
          filter,true
        );
        if (this.bookmarkTopicDataForEdit["status"] == 200) {
          this.showSaveBookmarkBtn = true;
          this.bookmarkForm.controls["title"].patchValue(
            this.bookmarkTopicDataForEdit["content"]["title"]
          );
          this.bookmarkForm.controls["filter_start"].patchValue(
            this.getReadableTime(this.bookmarkTopicDataForEdit["content"]["filter_start"], true)
          );
          this.bookmarkForm.controls["filter_end"].patchValue(
            this.getReadableTime(this.bookmarkTopicDataForEdit["content"]["filter_end"], true)
          );
          this.resetDDMenu(this.bookmarkTopicList);
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      }
    });
  }

  async onDeleteBookmarkTopic(bookmarkTopic) {
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          class_room_video_details_id: this.router.snapshot.queryParams.key,
          id: bookmarkTopic.id,
          role_id: this.storageService.getRole(),
        };
        let deleteBookmarkTopic = await this.globalService.delete(
          "bookmark/delete",
          filter
        );
        await this.getBookmarkTopics();
        if (deleteBookmarkTopic["status"] === 200) {
          Swal.fire("Success!", deleteBookmarkTopic["message"], "success");
        } else {
          this.spinner.hide();
        }
      }
    });
  }

  onClickThreeDotMenu(bookmarkTopic) {
    this.bookmarkTopicList = this.bookmarkTopicList?.map((list) => {
      if (bookmarkTopic.id == list.id) {
        list.isDDMenuShow = !list.isDDMenuShow;
      } else {
        list.isDDMenuShow = false;
      }
      return list;
    });
  }
}
